import { useTheme } from '@mui/material';
const useRecentIncidentCardStyles = () => {
    const theme = useTheme();
    return {
        recentIncidentCardStyles: {
            display: 'flex',
            flexDirection: 'row',
            flex: '1 0 0',
            p: 1,
            gap: 1.5,
            borderRadius: 1,
            border: `1px solid ${theme.palette.divider}`,
            background: theme.palette.background.paper,
            // boxShadow: theme.customShadows.z4
        },
        incidentPreviewContainerStyles: {
            borderRadius: '6px',
            overflow: 'hidden',
            height: 96,
            width: 96,
            img: {
                height: 96,
                width: 96,
                display: 'flex',
                objectFit: 'cover',
                backgroundRepeat: 'no-repeat'
            }
        },
        incidentDetailsContainerStyles: {
            display: 'flex',
            flexDirection: 'column',
            // gap: 1
        },
        headerStyles: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        bodyContentStyles: {
            span: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px'
            }
        }
    };
};
export default useRecentIncidentCardStyles;
